<template lang="pug">
  Icon.icon(name="notification-lightning" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Ваш аккаунт заблокирован из-за недостаточного количества средств на счету. Вы можете пополнить свой счёт или изменить тариф
    a(:href="$router.resolve({ name: 'tariffs' }).href")  здесь
</template>

<script>
export default {
  name: 'NotificationAccountBlocked',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
